import { action } from 'easy-peasy';
import { IActionResetCurrentVisit } from '../types';

const resetCurrentVisit: IActionResetCurrentVisit = action(state => {
  state.current = null;
});

export default resetCurrentVisit;
